<template>
  <div class="basic-block block-points-base" :style="styles">
    <div class="title-box">
      <h2>占いTVのポイント</h2>
      <img class="title-line" src="/static/img/recommend/lp/touwa/lp_titleline.svg" alt="">
    </div>
   
    <div class="content-wrap">
      <div class="block-points-base__inner">
      
        <ul class="point-ul">
          <li class="point-li"><img class="check_icon" src="/static/img/recommend/lp/touwa/icon_check.svg"><p> 占いコンテンツ<span class="pink font-w600">ナンバーワン企業</span>が運営する占いサービス</p></li>
          <li class="point-li"><img class="check_icon" src="/static/img/recommend/lp/touwa/icon_check.svg"><p> テレビやメディアで活躍中の占い師の占いが、月額528円で<span class="pink font-w600">占い放題</span></p></li>
          <li class="point-li"><img class="check_icon" src="/static/img/recommend/lp/touwa/icon_check.svg"><p> <span class="pink font-w600">2000以上</span>の占いを、24時間いつでも<span class="pink font-w600">文章や動画でサクッと</span>見られる</p></li>
          <li class="point-li"><img class="check_icon" src="/static/img/recommend/lp/touwa/icon_check.svg"><p> <span class="pink font-w600">いつ入会しても</span>、定額で<span class="pink font-w600">一か月使い放題</span>。解約も超カンタン！</p></li>
          <li class="point-li"><img class="check_icon" src="/static/img/recommend/lp/touwa/icon_check.svg"><p> 月額会員限定の<span class="pink font-w600">特典多数</span></p></li>
        </ul>

       
        <div class="btn-area">
          <span class="button-link" @click="clickedSubsc"><span class="button-face">登録して占う</span></span>
        </div>
        
        
      </div>
    </div>
   
  </div>
</template>

<script>

import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'



export default {
  name: 'BlockPoints',
  components: {
    LpBaseButton,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    lpId: Number,
    subscUrl: String,
    gaTarget: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    clickedSubsc() {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${this.gaTarget}-subsc-button`,
        'event_label': 'point1',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
  
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

$uranaitv_black :#32373f;
$uranaitv_pink :#ff7497;

.block-points-base {
  background: #fff;
  padding: 40px 0 0;
  h2{
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 30px;
    color: $uranaitv_black;
    margin:0;
    margin-bottom: 16px;
  }
  .title-box {
    text-align: center;
  }
  .title-line{
    margin-bottom: 24px;
  }
  

  &__inner {
    padding: 0 20px 20px;
    background: #fff;
   
  }
  .point-ul{
    margin:auto;
    margin-bottom: 40px;
    max-width: 490px;
    padding-left: 0;
  }
  .point-li{
    display: flex;
    margin-bottom: 16px;
    p{
      margin:0;
    }
  }
  .check_icon{
    margin-right:8px;
  }

  .pink{
    color:$uranaitv_pink;
  }
  .font-w600{
    font-weight: 600;
  }
  
  .baseButton {
    width: 80%;
    max-width: 382px;
    margin: auto;
    /deep/ {
      .baseButton__button--primary {
        background: #6799CB;
        .baseButton__button__label {
          color: #6799CB;
          &::after {
            background-color: #6799CB;
          }
        }
      }
    }
  }

}


.btn-area {
  max-width: 315px;
  margin: auto;
}
.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position:relative;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;
  &::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:100px;
    padding:2px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
  }
  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /deep/ {
      .notice,
      .face-body{
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }
  &.disable {
    pointer-events: none;
    background: #dcdfe2;
    .button-face {
      color: #dcdfe2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockPoints.vue